module.exports = __webpack_public_path__ + "static/img/footer2.c475cc76.png";